import { render, staticRenderFns } from "./QueuesTagDeleteModal.vue?vue&type=template&id=167ce2f8&scoped=true"
import script from "./QueuesTagDeleteModal.vue?vue&type=script&lang=js"
export * from "./QueuesTagDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ce2f8",
  null
  
)

export default component.exports